import { render, staticRenderFns } from "./TheHomeSlogan.vue?vue&type=template&id=6f24e44d&scoped=true"
import script from "./TheHomeSlogan.vue?vue&type=script&lang=js"
export * from "./TheHomeSlogan.vue?vue&type=script&lang=js"
import style0 from "./TheHomeSlogan.vue?vue&type=style&index=0&id=6f24e44d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24e44d",
  null
  
)

export default component.exports